<template>
    <div class="row">
        <div class="col footer text-left">
            <span class="address-item">
                <h5 style="display:inline">IMMOCOACH AG</h5>
            </span>
            <span class="address-item">
                <h5 style="display:inline">Schärenmoosstrasse 78</h5>
            </span>
            <span class="address-item">
                <h5 style="display:inline">CH-8052 Zürich</h5>
            </span>
            <span class="address-item">
                <h5 style="display:inline">T +41 (0)44 322 44 77</h5>
            </span>
            <span class="address-item">
                <h5 style="display:inline">
                    <a
                        href="mailto:info@immocoach.ch"
                        target="_top"
                        class="email"
                        >info@immocoach.ch</a
                    >
                </h5>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style lang="scss" scoped>
@import '../styles/main.scss';

.address-item {
    margin-left: 8px;
    margin-right: 8px;
    display: inline;
}

.address-item a {
    color: black;
}

.footer {
    font-family: 'miso-light', Arial, sans-serif;
    padding-top: 50px;
    padding-bottom: 50px;
    padding-left: $main-indent;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue